<div class="merchant-info-bar">
  <em class="icon-merchant"></em>
  <span><strong>Merchant Name:</strong> {{ merchantName || '-' }} (Tax No.: {{ taxId || '-' }})</span>
</div>
